import { FormControl, Grid, Modal, OutlinedInput } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useState } from "react";
import { ApproveOrReject } from "../../../utils/consts";
import { useSelector } from "react-redux";
import useWithdrawTraining from "../../../hooks/trainingHooks/useWithdrawTraining";
import useRejectTraining from "../../../hooks/trainingHooks/useRejectTraining";
import useUpdateTrainingStatus from "../../../hooks/trainingHooks/useUpdateTrainingStatus";
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup";
import { rejectTrainingSchema } from "../../../utils/schema";



const styles = {
    box: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 600,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    },
    fullWidth: {
        width: '100%'
    }
};

const TrainingRejectModal = ({ open, setOpen, training }) => {
    const { trainingName } = training

    const [note, setNote] = useState('')
    const { email } = useSelector(state => state.user)
    const [trainingsSelected, setTrainingsSelected] = useState([])


    const { mutate: updateTrainingStatus } = useUpdateTrainingStatus(setTrainingsSelected)

    const { mutate: rejectTraining } = useRejectTraining()
    /*const {
        handleSubmit,
        control,
        reset,
        setValue,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(rejectTrainingSchema()),
    })*/

    const rejectTrainingHandler = () => {
        const ans = window.confirm("Are you sure you want to Reject the training?")
        if (ans) {
        const rejectedTraining = {
            trainingIds: training.id,
            approveOrReject: ApproveOrReject.REJECT,
            note,
        }
        updateTrainingStatus(rejectedTraining)
        closeForm()
        }else {
            closeForm()
        }
    }

    const closeForm = () => {
        setOpen(false)
    }

    return (
        <>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styles.box}>
                    <Grid
                        container
                        direction="column"
                        justifyContent="space-around"
                        alignItems="stretch"
                        spacing={2}
                    >
                        <Grid item>
                            <Typography id="modal-modal-title" variant="subtitle">
                                Are you absolutely sure?
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }} variant='body2'>
                                This action <b>cannot</b> be undone.
                                This will reject the <b>{trainingName}</b> training.
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }} variant='body2'>
                                Please type <b>rejection reason</b> to confirm.
                            </Typography>
                        </Grid>
                        <Grid item>
                            <FormControl sx={{ width: '100%' }} variant="outlined" size="small">
                                <OutlinedInput
                                    id="outlined-adornment-withdraw-notice"
                                    name="note"
                                    aria-describedby="outlined-withdraw-notice-helper-text"
                                    inputProps={{
                                        'aria-label': 'notice',
                                    }}
                                    onChange={e => setNote(e.target.value)}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <Grid
                                container
                                alignItems='center'
                                justifyContent='center'
                                spacing={1}
                            >
                                <Grid item>
                                    <Button
                                        // disabled={trainingNameTyped !== trainingName}
                                        variant="contained"
                                        disableElevation
                                        color='error'
                                        size="small"
                                        onClick={()=>rejectTrainingHandler()}
                                    >
                                        Reject this training
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        variant="outlined"
                                        onClick={() => closeForm()}
                                    >
                                        Cancel
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </>
    )
}

export default TrainingRejectModal
